// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://dev.slabs.igmcorp.net/api/v1/',
  cosmosgranitebaseUrl: 'https://surfaces.cosmosgranite.com/api/',
  siteKey: '6LfBH_0ZAAAAAO-_knQytXdQohMUyPFZU2tJzbQm'

};

// export const environment = {
//   production: false,
//   baseUrl: 'https://slabs.igmsurfaces.com/api/v1/',
//   cosmosgranitebaseUrl: 'https://surfaces.cosmosgranite.com/api/',
//   siteKey: '6LfBH_0ZAAAAAO-_knQytXdQohMUyPFZU2tJzbQm'

// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
